import React from 'react';
import { TextButton } from 'js/design_system/TextButton';
import { Button } from 'js/design_system/Button';
type Props = {
  buttonText: string;
  userInChina?: boolean;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export const ContinueWithEmailButton: React.FC<Props> = (props) => {
  const { onClick, disabled, buttonText, userInChina, ...buttonProps } = props;

  const commonProps = {
    onClick: disabled ? () => {} : onClick,
    disabled,
    children: buttonText,
    ...buttonProps,
  };
  return userInChina ? (
    <Button {...commonProps} />
  ) : (
    <TextButton icon="email" {...commonProps} />
  );
};
